<template>
  <div class="page_scheduledJobManage">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div class="flex aic">
          <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="88px" size="small">
            <el-form-item label="用户ID" size="small">
              <el-input-number v-model="listQuery.userId" :min="1" :controls="false" size="small" style="width:140px" @keyup.enter.native="searchHandle"></el-input-number>
            </el-form-item>
            <el-form-item label="状态" size="small">
              <el-select v-model="listQuery.status" placeholder="" clearable size="small" style="width:140px">
                <el-option v-for="(name, idx) in statusNames" :key="idx" :label="name" :value="String(idx)"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="每页" size="small">
              <el-select v-model="listQuery.pageSize" size="small" style="width:110px" @change="searchHandle">
                <el-option :value="20" label="20 条"></el-option>
                <el-option :value="50" label="50 条"></el-option>
                <el-option :value="100" label="100 条"></el-option>
                <el-option :value="200" label="200 条"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="top-right">
        <el-checkbox v-model="autoRefresh" style="margin-right:15px">5 秒自动刷新</el-checkbox>
        <el-tag type="warning" size="small" style="margin-right:15px">{{ activeCount }} 个活动任务</el-tag>
        <el-button v-preventReClick type="success" size="small" @click="searchHandle" style="margin-right: 15px;">搜索</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>AI 工作台</el-breadcrumb-item>
          <el-breadcrumb-item>计划任务</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <div class="ftabBtn flex">
          <el-button type="primary" size="small" @click="load">立即刷新</el-button>
        </div>
        <el-table :data="tableData" border class="doc_table" v-loading="loading" style="width:100%">
          <el-table-column key="tool" label="计划任务 / 工具" min-width="180" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row}">
              <strong>{{ row.toolName }}</strong><br>
              <small>{{ row.id }}</small>
            </template>
          </el-table-column>
          <el-table-column key="scheduled" label="执行时间" min-width="180" align="center">
            <template slot-scope="{row}">
              <strong>{{ row.scheduledLocalTime || formatTime(row.scheduledTime) }}</strong><br>
              <small>{{ row.timeZone }} · {{ remaining(row) }}</small>
            </template>
          </el-table-column>
          <el-table-column key="status" label="状态" min-width="140" align="center">
            <template slot-scope="{row}">
              <el-tag :type="statusTagType(row.status)" size="mini">{{ statusNames[row.status] || '未知' }}</el-tag>
              <small v-if="row.cancelRequested && row.status === 1" style="display:block">取消请求传播中</small>
              <small v-else-if="row.errorCode" style="display:block">{{ row.errorCode }}</small>
            </template>
          </el-table-column>
          <el-table-column key="retry" label="重试" min-width="160" align="center">
            <template slot-scope="{row}">
              <span>失败 {{ row.retryCount }} 次</span><br>
              <small>允许重试 {{ row.maxRetryCount }} 次</small>
              <small v-if="row.nextRetryTime" style="display:block">下次 {{ row.nextRetryLocalTime || formatTime(row.nextRetryTime) }}</small>
            </template>
          </el-table-column>
          <el-table-column key="createTime" label="创建时间" min-width="150" align="center">
            <template slot-scope="{row}">{{ formatTime(row.createTime) }}</template>
          </el-table-column>
          <el-table-column key="action" label="操作" fixed="right" align="center" width="180">
            <template slot-scope="{row}">
              <div class="injuryTabBtn">
                <el-button type="text" size="small" @click="showDetail(row)">详情</el-button>
                <el-button v-if="row.status === 0 || row.status === 1" type="text" size="small" :loading="canceling === row.id" @click="cancelJob(row)">取消</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <el-pagination v-if="totalCount > 0" @current-change="currentChange" :current-page.sync="listQuery.page" :page-size="Number(listQuery.pageSize)" @size-change="handleSizeChange" :page-sizes="[20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>

    <!-- 任务详情 -->
    <el-dialog :title="selected ? selected.toolName : '计划任务详情'" :visible.sync="detailOpen" width="900px" class="res_dialog" :close-on-click-modal="false" top="5vh">
      <template v-if="selected">
        <div style="margin-bottom:10px;color:#909399;font-size:13px">{{ selected.id }}</div>
        <el-row :gutter="12" class="summary-grid">
          <el-col :span="6">
            <div class="summary-card">
              <span>状态</span>
              <strong><i class="status-dot" :data-job-status="selected.status"></i>{{ statusNames[selected.status] }}</strong>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="summary-card">
              <span>计划执行</span>
              <strong>{{ selected.scheduledLocalTime || formatTime(selected.scheduledTime) }}</strong>
              <small>{{ selected.timeZone }}</small>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="summary-card">
              <span>失败 / 重试</span>
              <strong>{{ selected.retryCount }} / {{ selected.maxRetryCount }} 次</strong>
              <small>{{ selected.nextRetryTime ? `下次 ${selected.nextRetryLocalTime || formatTime(selected.nextRetryTime)}` : '无待执行重试' }}</small>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="summary-card">
              <span>来源</span>
              <strong>Agent #{{ selected.agentId }}</strong>
              <small>Task {{ selected.sourceTaskId }}</small>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="12" class="json-grid">
          <el-col :span="12"><h4>工具参数</h4><pre>{{ prettyJson(selected.arguments) }}</pre></el-col>
          <el-col :span="12"><h4>执行结果</h4><pre>{{ prettyJson(selected.result) }}</pre></el-col>
        </el-row>
        <div v-if="selected.errorMessage" class="job-error">
          <strong>{{ selected.errorCode || 'EXECUTION_ERROR' }}</strong>
          <p>{{ selected.errorMessage }}</p>
        </div>
        <template v-if="selected.events && selected.events.length">
          <div class="section-heading"><strong>执行事件</strong></div>
          <div class="job-event-list">
            <div v-for="event in selected.events" :key="event.sequence" class="event-row">
              <strong>#{{ event.sequence }} {{ event.eventType }}</strong>
              <span>{{ event.message }}</span>
              <small>{{ formatTime(event.createTime) }}</small>
            </div>
          </div>
        </template>
        <div class="section-heading" style="margin-top:14px"><strong>时间线</strong></div>
        <div class="job-time-line">
          <span>创建 {{ formatTime(selected.createTime) }}</span>
          <span>开始 {{ formatTime(selected.startTime) }}</span>
          <span>最近尝试 {{ formatTime(selected.lastAttemptTime) }}</span>
          <span>结束 {{ formatTime(selected.finishTime) }}</span>
          <span>更新 {{ formatTime(selected.updateTime) }}</span>
        </div>
      </template>
      <span slot="footer" class="dialog-footer">
        <el-button v-if="selected && (selected.status === 0 || selected.status === 1)" type="danger" size="small" @click="cancelJob(selected)">取消任务</el-button>
        <el-button @click="detailOpen = false" size="small">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import xz from "../../common";
  import signalR from '@/utils/signalR';
  const APIAwBase = 'http://10.0.0.10:2205';
  export default {
    data() {
      return {
        statusNames: ['待执行', '执行中', '成功', '失败', '已取消'],
        listQuery: { userId: Number(Cookies.get("userid-b")) || 1, status: '', page: 1, pageSize: 50 },
        tableData: [],
        totalCount: 0,
        loading: false,
        autoRefresh: true,
        detailOpen: false,
        canceling: '',
        selected: null,
        now: Date.now(),
        refreshError: '',
        connection: null,
        subscribedUserId: null,
        timer: null
      }
    },
    computed: {
      activeCount() {
        return this.tableData.filter(item => item.status === 0 || item.status === 1).length;
      }
    },
    created() {
      this.load();
      this.connectRealtime();
      this.timer = window.setInterval(() => {
        this.now = Date.now();
        if (this.autoRefresh) this.load(true);
      }, 5000);
    },
    beforeDestroy() {
      window.clearInterval(this.timer);
      signalR.stopConnection(this.connection);
    },
    methods: {
      currentChange(val) {
        this.listQuery.page = Number(val);
        this.load();
      },
      handleSizeChange(val) {
        this.listQuery.page = 1;
        this.listQuery.pageSize = val;
        this.load();
      },
      searchHandle() {
        this.listQuery.page = 1;
        this.load();
      },
      buildPayload() {
        return {
          userId: Number(this.listQuery.userId),
          status: this.listQuery.status === '' ? null : Number(this.listQuery.status),
          pagination: { page: this.listQuery.page, pageSize: this.listQuery.pageSize }
        };
      },
      load(silent) {
        if (Number(this.listQuery.userId) <= 0) {
          this.$message.error('User ID 必须大于 0');
          return;
        }
        if (!silent) this.loading = true;
        xz.getScheduledJobPage(this.buildPayload()).then(res => {
          if (res) {
            this.tableData = res.data || [];
            this.totalCount = res.totalCount || 0;
          } else if (!silent) {
            this.tableData = [];
            this.totalCount = 0;
          }
          this.now = Date.now();
          this.refreshError = '';
          this.subscribeRealtime();
          if (this.selected) {
            if (this.detailOpen) {
              this.refreshSelectedDetail();
            } else {
              this.selected = this.tableData.find(item => item.id === this.selected.id) || this.selected;
            }
          }
          this.loading = false;
        }).catch((err) => {
          this.refreshError = err && err.message ? err.message : '加载失败';
          if (!silent) { this.tableData = []; this.totalCount = 0; this.loading = false; }
        });
      },
      refreshSelectedDetail() {
        xz.getScheduledJobDetail(this.selected.id, Number(this.listQuery.userId)).then(res => {
          if (res) this.selected = res;
        }).catch(() => {});
      },
      showDetail(item) {
        xz.getScheduledJobDetail(item.id, Number(this.listQuery.userId)).then(res => {
          if (res) {
            this.selected = res;
            this.detailOpen = true;
          } else {
            this.$message.error('获取详情失败');
          }
        });
      },
      cancelJob(item) {
        this.$confirm(`确定取消计划任务「${item.toolName}」吗？`, '提示', { type: 'warning' }).then(() => {
          this.canceling = item.id;
          xz.cancelScheduledJob(item.id, Number(this.listQuery.userId)).then(res => {
            this.canceling = '';
            if (res !== false) { this.$message.success('取消请求已提交'); this.load(true); }
            else this.$message.error('取消失败');
          }).catch(() => { this.canceling = ''; });
        }).catch(() => {});
      },
      remaining(item) {
        if (item.status !== 0) return this.statusNames[item.status] || '未知';
        let target = new Date(item.nextRetryTime || item.scheduledTime).getTime() - this.now;
        if (target <= 0) return '等待 Worker 领取';
        let seconds = Math.ceil(target / 1000);
        let days = Math.floor(seconds / 86400);
        let hours = Math.floor(seconds % 86400 / 3600);
        let minutes = Math.floor(seconds % 3600 / 60);
        let rest = seconds % 60;
        return days > 0 ? `${days}天 ${hours}小时` : hours > 0 ? `${hours}小时 ${minutes}分` : `${minutes}分 ${rest}秒`;
      },
      statusTagType(val) {
        if (val === 2) return 'success';
        if (val === 3) return 'danger';
        if (val === 4) return 'info';
        if (val === 1) return 'warning';
        return 'info';
      },
      formatTime(value) {
        return value ? new Date(value).toLocaleString('zh-CN', { hour12: false }) : '—';
      },
      prettyJson(value) {
        if (!value) return '—';
        try { return JSON.stringify(typeof value === 'string' ? JSON.parse(value) : value, null, 2); }
        catch (e) { return String(value); }
      },
      async subscribeRealtime() {
        if (!this.connection || this.connection.state !== 'Connected') return;
        let next = Number(this.listQuery.userId);
        if (this.subscribedUserId === next) return;
        if (this.subscribedUserId) {
          try { await this.connection.invoke('LeaveScheduledJobs', this.subscribedUserId); } catch (e) {}
        }
        try { await this.connection.invoke('JoinScheduledJobs', next); this.subscribedUserId = next; } catch (e) {}
      },
      async connectRealtime() {
        this.connection = signalR.createConnection(`${APIAwBase}/agentHub`);
        this.connection.on('scheduled_job_event', () => { this.load(true); });
        this.connection.onreconnected(async () => {
          this.subscribedUserId = null;
          await this.subscribeRealtime();
          await this.load(true);
        });
        this.connection.onclose(() => { this.subscribedUserId = null; });
        const ok = await signalR.startConnection(this.connection);
        if (!ok) {
          this.refreshError = '实时连接失败，将继续使用定时刷新';
        } else {
          this.subscribeRealtime();
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 0px 16px 16px;
    margin-bottom: 16px;
  }
  .ftabBtn {
    padding: 10px 0;
  }
  .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }
  .section-heading {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 12px 0 8px;
  }
  .summary-grid {
    margin-bottom: 8px;
  }
  .summary-card {
    border: 1px solid #ebeef5;
    border-radius: 4px;
    padding: 10px;
    text-align: center;
    span { display: block; color: #909399; font-size: 12px; }
    strong { display: block; font-size: 16px; margin: 4px 0; display: flex; align-items: center; justify-content: center; gap: 6px; }
    small { color: #909399; font-size: 12px; }
  }
  .json-grid {
    h4 { margin: 6px 0 4px; color: #606266; font-size: 13px; }
    pre { background: #f5f7fa; border: 1px solid #ebeef5; border-radius: 4px; padding: 8px; font-size: 12px; max-height: 240px; overflow: auto; white-space: pre-wrap; word-break: break-all; }
  }
  .job-error {
    background: #fef0f0;
    border: 1px solid #fde2e2;
    border-radius: 4px;
    padding: 8px 10px;
    margin: 8px 0;
    strong { color: #f56c6c; }
    p { margin: 4px 0 0; color: #f56c6c; font-size: 13px; }
  }
  .job-event-list {
    max-height: 280px;
    overflow: auto;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    .event-row {
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 6px 10px;
      border-bottom: 1px solid #f0f2f5;
      font-size: 13px;
      strong { min-width: 150px; color: #19bd92; }
      span { flex: 1; color: #606266; }
      small { color: #909399; }
    }
  }
  .job-time-line {
    display: flex;
    flex-wrap: wrap;
    gap: 14px;
    color: #909399;
    font-size: 12px;
    padding: 8px 10px;
    background: #f5f7fa;
    border-radius: 4px;
  }
  .status-dot {
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #909399;
    &[data-job-status="0"] { background: #e6a23c; }
    &[data-job-status="1"] { background: #409eff; }
    &[data-job-status="2"] { background: #67c23a; }
    &[data-job-status="3"] { background: #f56c6c; }
    &[data-job-status="4"] { background: #909399; }
  }
</style>
<style>
  .page_scheduledJobManage .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }
  .page_scheduledJobManage .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }
  .page_scheduledJobManage .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }
</style>
